export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center bg-background-50 overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 70% 60% at 30% 50%, oklch(var(--primary-50)), oklch(var(--background-50)))' }}></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>每日更新 50+ 章节</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-5">
              妖精漫画网
              <span className="block text-primary-500">韩漫日漫国漫大全</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              妖精漫画网汇集海量<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>，打造最全<strong>漫画大全</strong>与<strong>漫画全集</strong>阅读平台。无论你热衷韩国热血漫、日本经典连载还是国产原创佳作，都能在这里找到心仪的作品。下拉式流畅阅读、高清画质呈现，每日同步更新热门连载，让你随时随地畅享<strong>免费漫画</strong>的快乐。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-primary-500">100,000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-secondary-500">800万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃读者</div>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-4 flex-wrap">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                开始探索漫画
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-7 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full font-medium text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20collage%20illustration%20with%20multiple%20characters%20from%20different%20genres%20action%20romance%20fantasy%2C%20vibrant%20warm%20colors%20orange%20red%20golden%20tones%2C%20dynamic%20composition%20with%20manga%20panel%20layout%20effect%2C%20Japanese%20Korean%20Chinese%20comic%20art%20fusion%2C%20energetic%20and%20eye-catching%2C%20clean%20background%20with%20warm%20gradient&width=700&height=900&seq=hero-manga-visual&orientation=portrait"
                alt="妖精漫画 — 韩漫日漫国漫大全视觉插图"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute -bottom-3 -left-3 right-3 top-3 border-2 border-primary-300/40 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}